export enum ProductsConfigKeyEnum {
  ReguardActive = 'reguard.active',
  ResourceActive = 'resource.active',
  WaterSectionsQualityVideoHash = 'water.sections.quality.videoHash',
  HeatingSectionsFreedomVideoHash = 'heating.sections.freedom.videoHash',
  SewageSectionsIntroductionVideoHash = 'sewage.sections.introduction.videoHash',
  TemperatureRegulatorSectionsSmartVideoVideoHash = 'temperature_regulator.sections.smart.video.videoHash',
  TemperatureRegulatorSectionsSmartGeofencingVideoHash = 'temperature_regulator.sections.smart.geofencing.videoHash',
}
